<template>
  <div>
    <v-row dense>
      <v-col cols="12">
        <v-card color="lightGrey">
          <div class="flex-wrap justify-space-between">
            <div xs12>
              <v-card-title>
                Obsługiwane kategorie
              </v-card-title>
              <div class="d-md-flex flex-row-reverse">
                <v-card-text v-if="!isLoading">
                  <v-form>
                    <v-treeview
                        :items="originUserCategories"
                        item-children="categories"
                    >
                      <template v-slot:prepend="{ item }">
                        <v-checkbox
                            v-model="userCategories[item.id].value"
                            :indeterminate="getIState(item)"
                            @change="handleCategoryChange(item.id)"
                            color="primary"
                        ></v-checkbox>
                      </template>

                      <template v-slot:label="{ item }">
                        <span class="category-tree--label">{{
                            item.name
                          }}</span>
                      </template>
                    </v-treeview>
                  </v-form>
                </v-card-text>
              </div>
              <v-card-actions v-if="showSave">
                <v-spacer />
                <v-btn
                    @click="save"
                    class="wastemaster--btn wastemaster--border-success"
                >Zapisz&nbsp;<v-icon size="24" right
                >mdi-content-save-outline</v-icon
                ></v-btn
                >
              </v-card-actions>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import categoryMixin from '@/mixins/categoryMixin'
import api from "@/services/api";

export default {
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    showSave: {
      type: [Boolean],
      required: false,
      default: true
    },
  },
  name: 'CompanyCategories',
  mixins: [categoryMixin],
  data: () => ({
    hasCategoryChanged: false,
    hasRegionsChanged: false,
    userRanges: {},
    userCategories: [],
    originUserCategories: [],
    isLoading: true,
    isComingFromOffers: false
  }),
  mounted() {
    const arr = []
    this.getCompanyCategories().then(() => {
      this.addToUserCategoriesRecursively(
          arr,
          this.companyCategories,
          null
      )
      this.userCategories = arr
      this.updateAllCheckboxes()
      this.originUserCategories = this.companyCategories
      this.isLoading = false
      this.hasCategoryChanged = false
    })
  },
  methods: {
    getIState(item) {
      return this.userCategories[item.id].indeterminate
    },
    filterCategories(item, queryText) {
      if (String(item.name).includes(queryText)) {
        return true
      }
      if (item.codes) {
        return Array(item.codes).some(function(v) {
          return String(v).includes(String(queryText))
        })
      }
      return false
    },
    getCompanyCategories() {
      return new Promise((resolve, reject) => {
        api.get(
                'api/companies/' + this.id + '/categories',
            )
            .then((data) => {
              this.companyCategories = data.data
              resolve(true)
            })
            .catch((error) => {
              reject(error)
            })
      })
    },
    addToUserCategoriesRecursively(arr, categories, parent) {
      if (categories) {
        categories.forEach((category) => {
          arr[category.id] = {
            id: category.id,
            value: false,
            indeterminate: false,
            usesRanges: category.usesRanges,
            parent: parent ? parent.id : null,
            children: category.categories
                ? category.categories.map((cc) => cc.id)
                : [],
            siblings: categories
                .filter((c) => c.id !== category.id)
                .map((c) => c.id)
          }
          this.userRanges[category.id + '-1'] = category.ranges.range1
          this.userRanges[category.id + '-2'] = category.ranges.range2
          this.userRanges[category.id + '-3'] = category.ranges.range3
          if (category.categories && category.categories.length > 0) {
            this.addToUserCategoriesRecursively(
                arr,
                category.categories,
                category
            )
          }
        })
      } else {
        console.warn('There is no defined categories')
      }
    },
    /**
     * Handles changing category state.
     * Propagates change through all its child and parent.
     * Handles changing corresponding ranges.
     *
     * @param id ID of an element
     */
    handleCategoryChange(categoryId) {
      const userCategory = this.userCategories[categoryId]
      const checked = userCategory.value
      const range = {
        0: {
          indeterminate: false,
          value: checked
        },
        1: {
          indeterminate: false,
          value: checked
        },
        2: {
          indeterminate: false,
          value: checked
        }
      }
      this.updateVolumesRecursivelyDown(categoryId, range)
      this.updateCheckboxRecursivelyDown(categoryId)
      this.updateCheckboxRecursivelyUp(this.userCategories[categoryId].parent)
    },
    updateVolumes(categoryId, ranges) {
      if (this.usesRanges(this.userCategories[categoryId])) {
        this.userRanges[categoryId + '-1'] = ranges[0].indeterminate
            ? this.userRanges[categoryId + '-1']
            : ranges[0].value
        this.userRanges[categoryId + '-2'] = ranges[1].indeterminate
            ? this.userRanges[categoryId + '-2']
            : ranges[1].value
        this.userRanges[categoryId + '-3'] = ranges[2].indeterminate
            ? this.userRanges[categoryId + '-3']
            : ranges[2].value
      } else {
        const value = ranges[0].value || ranges[1].value || ranges[2].value
        this.userRanges[categoryId + '-1'] = value
        this.userRanges[categoryId + '-2'] = value
        this.userRanges[categoryId + '-3'] = value
      }
    },
    updateVolumesRecursivelyDown(categoryId, range) {
      const userCategory = this.userCategories[categoryId]
      if (
          userCategory &&
          userCategory.children &&
          userCategory.children.length > 0
      ) {
        userCategory.children.forEach((childId) => {
          this.updateVolumesRecursivelyDown(childId, range)
        })
      } else {
        this.updateVolumes(categoryId, range)
      }
    },
    updateCheckbox(categoryId, ranges) {
      // state to determine if tree has changed and should be saved
      this.hasCategoryChanged = true
      this.userCategories[categoryId].value =
          ranges[0].value && ranges[1].value && ranges[2].value
      const category = this.userCategories[categoryId]
      if (category.children && category.children.length > 0) {
        this.userCategories[categoryId].indeterminate =
            ranges[0].indeterminate ||
            ranges[1].indeterminate ||
            ranges[2].indeterminate ||
            (!this.userCategories[categoryId].value &&
                (ranges[0].value || ranges[1].value || ranges[2].value))
      } else {
        this.userCategories[categoryId].indeterminate =
            !this.userCategories[categoryId].value &&
            (ranges[0].value || ranges[1].value || ranges[2].value)
      }
    },
    updateAllCheckboxes() {
      this.userCategories
          .filter((uc) => !uc.children || uc.children.length === 0)
          .forEach((uc) => {
            this.updateCheckboxRecursivelyUp(uc.id)
          })
    },
    updateCheckboxRecursivelyUp(categoryId) {
      if (categoryId) {
        const volume1 = this.getSingleVolumeObject(categoryId, 1)
        const volume2 = this.getSingleVolumeObject(categoryId, 2)
        const volume3 = this.getSingleVolumeObject(categoryId, 3)
        this.updateCheckbox(categoryId, {
          0: volume1,
          1: volume2,
          2: volume3
        })
        const category = this.userCategories[categoryId]
        this.updateCheckboxRecursivelyUp(category.parent)
      }
    },
    updateCheckboxRecursivelyDown(categoryId) {
      const userCategory = this.userCategories[categoryId]
      if (
          userCategory &&
          userCategory.children &&
          userCategory.children.length > 0
      ) {
        userCategory.children.forEach((childId) => {
          this.updateCheckboxRecursivelyDown(childId)
          const volume1 = this.getSingleVolumeObject(categoryId, 1)
          const volume2 = this.getSingleVolumeObject(categoryId, 2)
          const volume3 = this.getSingleVolumeObject(categoryId, 3)
          this.updateCheckbox(categoryId, {
            0: volume1,
            1: volume2,
            2: volume3
          })
        })
      } else {
        const volume1 = this.getSingleVolumeObject(categoryId, 1)
        const volume2 = this.getSingleVolumeObject(categoryId, 2)
        const volume3 = this.getSingleVolumeObject(categoryId, 3)
        this.updateCheckbox(categoryId, {
          0: volume1,
          1: volume2,
          2: volume3
        })
      }
    },
    getSingleVolumeObject(categoryId, volumeNr) {
      const category = this.userCategories[categoryId]
      if (category.children && category.children.length > 0) {
        const childrenIds = this.userCategories[categoryId].children
        const firstChildVolume = this.getSingleVolumeObject(
            childrenIds[0],
            volumeNr
        )
        for (let i = 1; i < childrenIds.length; i++) {
          if (
              firstChildVolume.indeterminate ||
              this.getSingleVolumeObject(childrenIds[i], volumeNr)
                  .indeterminate ||
              !!firstChildVolume.value !==
              !!this.getSingleVolumeObject(childrenIds[i], volumeNr).value
          ) {
            return {
              indeterminate: true,
              value: false
            }
          }
        }
        return firstChildVolume
      }

      return {
        indeterminate: false,
        value: this.userRanges[categoryId + '-' + volumeNr]
      }
    },
    openVolumeDialog(item) {
      const ranges = {}
      ranges[0] = this.getSingleVolumeObject(item.id, 1)
      ranges[1] = this.getSingleVolumeObject(item.id, 2)
      ranges[2] = this.getSingleVolumeObject(item.id, 3)

      const promise = new Promise((resolve, reject) => {
        this.$bus.$emit('volume-options-dialog', ranges, resolve, reject)
      })

      promise
          .then((receivedRanges) => {
            if (JSON.stringify(ranges) !== JSON.stringify(receivedRanges))
              this.updateVolumesRecursivelyDown(item.id, receivedRanges)
            this.updateCheckboxRecursivelyDown(item.id, receivedRanges)
            this.updateCheckbox(item.id, receivedRanges)
            this.updateCheckboxRecursivelyUp(item.id)
          })
          /* eslint-disable no-console */
          .catch((err) => console.log(err))
    },
    usesRanges(item) {
      return item.usesRanges
    },
    save() {
      this.saveCategories()
          .then(() => {
            this.$root.$emit('notifySuccess', {
              html: 'Kategorie zostały zapisane.',
            });
          })
          .catch(() => {
            this.$root.$emit('notifyError', {
              html: 'Wystąpił błąd.',
            });
          })
    },
    saveCategories(customId) {
      let id = this.id;
      if (customId !== undefined) {
        id = customId;
      }
      if (this.hasCategoryChanged) {
        const rangesObjectToSave = this.userCategories
            .filter((uc) => !!uc)
            .map((uc) => {
              return {
                id: uc.id,
                ranges: {
                  range1: this.getSingleVolumeObject(uc.id, 1).value,
                  range2: this.getSingleVolumeObject(uc.id, 2).value,
                  range3: this.getSingleVolumeObject(uc.id, 3).value
                }
              }
            })
        return this.saveCompanyCategories(id, rangesObjectToSave)
      } else {
        return new Promise((resolve) => {
          resolve(true)
        })
      }
    },
    saveCompanyCategories(id, rangesObject) {
      return new Promise((resolve, reject) => {
        api.put(
                'api/companies/' + id + '/categories',
                { categories: rangesObject },
            )
            .then((data) => {
              this.companyCategories = data
              resolve(true)
            })
            .catch((error) => {
              reject(error)
            })
      })
    },
  }
}
</script>

<style scoped>
.category-tree--label {
  width: 90%;
  white-space: break-spaces;
  vertical-align: middle;
  display: inline-block;
}
</style>
